import React, { useEffect } from 'react';
import Modal from 'react-responsive-modal';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { Button } from '@synergy-marine-group/synergy-ui';
import CreatableSelect from 'react-select/creatable';
import { ppeComponentModalStyles } from '../Modal/styles';
import DropdownFieldComponent from '../common/FormComponents/DropdownFieldComponent';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import createPpeComponentMaster from './queries/createPpeComponentMaster';
import updatePpeComponentMaster from './queries/updatePpeComponentMaster';
import showAlert from '../../utils/alert';

const validationSchema = Yup.object({
    name: Yup.string().trim().required('Please enter the Component Name'),
    unitPrice: Yup.number().required('Please enter the Unit Price (INR)').moreThan(0, 'Please enter a more than 0 value Amount'),
    unitPriceUsd: Yup.number().required('Please enter the Unit Price (USD)').moreThan(0, 'Please enter a more than 0 value Amount'),
    measurement: Yup.array().when('sizable', {
        is: true,
        then: Yup.array().min(1, 'Please select at least one Size'),
        otherwise: Yup.array().nullable()
    })
});
const AddComponent = ({ modal, setModal, items, setItems, mode, setMode }) => {
    const [sizes, setSize] = React.useState([]);

    const onChangeSize = (allSize, newItem) => {
      const filteredSizes = allSize.filter((size) => (size.label.trim().length > 0
      && size.label.trim().length <= 50));
        allSize.forEach((element) => {
          if (element.label.trim().length > 50) {
            showAlert('Size should not exceed 50 characters.', 'error');
        }
      });
      const newSize = filteredSizes.map((size) => size.label);
      if (newItem.action === 'create-option') {
        setSize(newSize);
      }
      if (newItem.action === 'remove-value') {
        const index = newSize.indexOf(newItem.removedValue.label);
        if (index > -1) {
          newSize.splice(index, 1);
        }
        setSize(newSize);
      }
    };

    useEffect(() => {
        if (items?.sizable) {
            setSize(items?.measurement);
        }
    }, [items]);

    const { mutate: createPpeComponent } = createPpeComponentMaster();
    const { mutate: updatePpeComponent } = updatePpeComponentMaster();
    const handleSubmit = (data) => {
        if (data.sizable) {
            data.measurement = sizes;
        } else {
            data.measurement = null;
        }
        if (mode === 'add') {
        createPpeComponent(data);
        } else {
        updatePpeComponent(data);
        }
        setModal(false);
        setMode('add');
       setItems({ name: '',
    sizable: false,
    isAdhoc: false,
    measurement: null,
    unitPriceUsd: '',
    unitPrice: ''
});
    };

    return (
    <Modal
    open={modal}
    onClose={() => setModal(false)}
    closeOnOverlayClick
    showCloseIcon={false}
    focusTrapped={false}
    styles={ppeComponentModalStyles}
    center
    >
      <div className="uppercase text-center font-bold text-xl pb-5 font-montserrat">
        {mode === 'add' ? 'Add Component' : 'Edit Component'}
      </div>
      <Formik
        initialValues={items}
        oncancel={() => setModal(false)}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({ values, errors, touched, setFieldValue }) => {
          useEffect(() => {
            if (values?.sizable === false) {
              setFieldValue('measurement', null);
            } else {
              setFieldValue('measurement', sizes);
            }
          },
           [values?.sizable, sizes]);
            return (
        <Form>
          <div className="w-auto ">
            <div className="align-middle align-center">
              <div className="grid grid-cols-2 gap-4 newDataError">
                <div className="col-span-2">
                  <Field
                    name="name"
                    component={InputFieldComponent}
                    className="w-full"
                    size="large"
                    rounded
                    requiredField
                    id="select1"
                    type="text"
                    label="Component Name"
                    maxLength={250}
                  />
                </div>
                <Field
                  name="sizable"
                  component={DropdownFieldComponent}
                  className="w-full"
                  options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}
                  size="large"
                  rounded
                  id="select1"
                  type="text"
                  label="Sizable"
                  maxMenuHeight={100}
                />
                <div className={values?.sizable ? 'flex flex-col place-items-start required-field' : 'flex flex-col place-items-start'}>
                <label className="text-sm font-muli ">Measurement</label>
                <CreatableSelect
                    isMulti
                    name="measurement"
                    required={values?.sizable}
                    isDisabled={!values?.sizable}
                    placeholder="Size"
                    formatCreateLabel={(inputValue) => `Add Size: ${inputValue}`}
                    label="Size"
                    className="multi-input w-full"
                    isClearable={false}
                    onChange={onChangeSize}
                    value={values?.sizable
                      ? sizes.map((size) => ({ label: size, value: size })) : []}
                    maxLength={50}
                    noOptionsMessage={() => null}
                />
                <div className="text-xs text-red-500">
                  {errors?.measurement && touched?.measurement ? errors?.measurement : null}
                </div>
                </div>
                <Field
                  name="unitPrice"
                  component={InputFieldComponent}
                  className="w-full"
                  size="large"
                  rounded
                  onInput={(e) => {
                    // eslint-disable-next-line prefer-destructuring
                    const value = e.target.value;
                    const regex = new RegExp(/^\d{1,13}(\.\d{1,2})?$/);
                    if (!regex.test(value)) {
                      e.target.value = value.slice(0, -1);
                    }
                  }}
                  id="select1"
                  type="number"
                  requiredField
                  onWheel={(e) => e.target.blur()}
                  label="Unit Price (INR)"
                />
                <Field
                  name="unitPriceUsd"
                  component={InputFieldComponent}
                  className="w-full"
                  size="large"
                  rounded
                  onInput={(e) => {
                    // eslint-disable-next-line prefer-destructuring
                    const value = e.target.value;
                    const regex = new RegExp(/^\d{1,13}(\.\d{1,2})?$/);
                    if (!regex.test(value)) {
                      e.target.value = value.slice(0, -1);
                    }
                  }}
                  id="select1"
                  type="number"
                  requiredField
                  onWheel={(e) => e.target.blur()}
                  label="Unit Price (USD)"
                />
              </div>
            </div>
          </div>
          {!(items?.name === values?.name
              && items?.unitPrice === values?.unitPrice
              && items?.unitPriceUsd === values?.unitPriceUsd
              && items?.isAdhoc === values?.isAdhoc
              && (items?.sizable === values?.sizable
              && JSON.stringify(items?.measurement) === JSON.stringify(sizes))) && (
                <span className="text-red-500 text-sm" hidden={mode === 'add'}>
                  The component details displayed on the Component Mapping screen will be modified.
                </span>
              )}
        <div className="flex items-center justify-between pt-8">
            <div className="flex items-center">
               <Field className="mr-2 rounded bg-gray-30 focus:ring-0 focus:outline-none" type="checkbox" name="isAdhoc" id="select1" />
              <label
                className="font-montserrat text-gray-500 text-sm font-bold ml-2"
              >
                Adhoc Item
              </label>
            </div>
          <div className="flex justify-end">
            <Button
              className="max-w-none mr-4 font-montserrat text-gray-500 uppercase text-sm"
              onClick={() => {
                setModal(false);
                setItems({ name: '',
                sizable: false,
                measurement: null,
                unitPrice: '',
                unitPriceUsd: '' });
              }}
              size="small"
              variant="outlined"
              rounded
              type="reset"
            >
              Discard
            </Button>

            <Button
            disabled={items?.name === values?.name
              && items?.unitPrice === values?.unitPrice
              && items?.isAdhoc === values?.isAdhoc
              && items?.unitPriceUsd === values?.unitPriceUsd
              && (items?.sizable === values?.sizable
              && JSON.stringify(items?.measurement) === JSON.stringify(sizes))}
            className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
            size="small"
            variant=" filled"
            rounded
            type="submit"
            >
              {mode === 'add' ? 'Add' : 'Update'}
            </Button>
          </div>
        </div>
        </Form>
        );
}}
      </Formik>
    </Modal>
  );
};

export default AddComponent;
